module.exports = __webpack_public_path__ + "static/media/29BDOS15.544e6400.jpg";